import { createContext, useState } from "react";

export const AddCouponFormContext = createContext();

export const AddCouponFormContextProvider = ({ children }) => {
    const dates = {
        from: null,
        to: null,
    };

    const defaultFormFields = {
        name: '',
        percentage: '',
        fixedPrice: '',
        purchaseAmount: '',
        limitAmount: '',
        buyAmount: '',
        getAmount: '',
    };

    const [formInputs, setFormInputs] = useState(defaultFormFields);
    const [date, setDate] = useState(dates);

    const [image, setImage] = useState({});

    const defaultFormErrors = {
        name: '',
        percentage: '',
        fixedPrice: '',
        purchaseAmount: '',
        limitAmount: '',
        collectionOrProduct: '',
        buyXgetX: ''
    };

    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const [purchaseRequirement, setPurchaseRequirement] = useState('');
    const [limitType, setLimitType] = useState('no-limit');
    const [selectionType, setSelectionType] = useState('');

    const [selectedProducts, setSelectedProducts] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState({});
    const [selectedCollection, setSelectedCollection] = useState({});
    const [selectedCustomCollection, setSelectedCustomCollection] = useState({});
    const [maxDiscount, setMaxDiscount] = useState('');

    const contextValue = {
        formInputs,
        setFormInputs,
        date,
        setDate,
        formErrors,
        setFormErrors,
        image,
        setImage,
        defaultFormErrors,
        purchaseRequirement,
        setPurchaseRequirement,
        limitType,
        setLimitType,
        selectedProducts,
        setSelectedProducts,
        selectionType,
        setSelectionType,
        selectedCategory,
        setSelectedCategory,
        selectedCollection,
        setSelectedCollection,
        selectedCustomCollection,
        setSelectedCustomCollection,
        maxDiscount,
        setMaxDiscount
    };

    return (
        <AddCouponFormContext.Provider value={ contextValue }>
            { children }
        </AddCouponFormContext.Provider>
    );
}
